$(document).ready(function(){
    // Function to get a cookie value by name
    function getCookie(name) {
        let cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            let cookiePair = cookies[i].split('=');
            if (cookiePair[0] === name) {
                return decodeURIComponent(cookiePair[1]); // Decode the stored value
            }
        }
        return null; // Return null if cookie not found
    }

    let age = getCookie("age");
    let weight = getCookie("weight");
    let desiredWeight = getCookie("desired_weight");
    var system = getCookie("system");
    var heightMetric = getCookie("heightMetric");
    var imperialHeightFt = getCookie("imperialHeightFt");
    var imperialHeightIn = getCookie("imperialHeightIn");
    var poop = getCookie("poop");
    let gender = getCookie("gender");


    function setResultsData(poop, age, weight, desiredWeight, system, heightMetric, imperialHeightFt, imperialHeightIn) {
        console.log("Poop: ", poop);
        console.log("Age:", age);
        console.log("Weight:", weight);
        console.log("Desired Weight:", desiredWeight);
        console.log('System:', system);
        console.log('Height Metric:', heightMetric);
        console.log('Height Imperial', imperialHeightFt);
        console.log('Height Imperial In', imperialHeightIn);

        if (system == 'imperial'){
            system = 'lbs';
        }
        else{
            system = 'kg';
        }

        weight = parseFloat(weight);
    
        let currentDate = new Date();
        let nextMonthDate = new Date();
        nextMonthDate.setMonth(currentDate.getMonth() + 1);
    
        let options = { month: 'short', year: 'numeric' };
        let formattedCurrentDate = currentDate.toLocaleDateString('en-US', options);
        let formattedNextMonthDate = nextMonthDate.toLocaleDateString('en-US', options);

        $('.weight-estimate-data').find('.estimate-data-left').find('.data-heading').html(weight + ' ' + system);
        $('.weight-estimate-data').find('.estimate-data-right').find('.data-heading').html(desiredWeight + ' ' + system);
    
        $('.weight-estimate-data').find('.estimate-data-left').find('.data-subheading').html(formattedCurrentDate);
        $('.weight-estimate-data').find('.estimate-data-right').find('.data-subheading').html(formattedNextMonthDate);

        // 2nd step

        var firstMonth = Math.round((parseFloat(weight) - parseFloat(desiredWeight)) * 0.75);
        var weeklyStep1 = firstMonth  * 0.4;
        var weeklyStep2 = firstMonth  * 0.2;
        var weeklyStep3 = firstMonth  * 0.2;
        var weeklyStep4 = firstMonth  * 0.2;

        var firstStep = Math.round(weight);
        var secondStep = Math.round(weight - weeklyStep1 );
        var thirdStep = Math.round(weight - weeklyStep1 - weeklyStep2 - weeklyStep3);
        var fourthStep = Math.round(weight - weeklyStep1 - weeklyStep2 - weeklyStep3 - weeklyStep4);

        $('.achievements-right').find('.right-title').html('-' + firstMonth + system);
        var index = 1;
        $('.graph-weight-info.graph-weight-list').find('li').each(function(){
            if (index == 1){
                $(this).find('.weight-text').html(firstStep + ' ' + system);
            }
            else if (index == 2){
                $(this).find('.weight-text').html(secondStep + ' ' + system);
            }
            else if (index == 3){
                $(this).find('.weight-text').html(thirdStep + ' ' + system);
            }
            else if (index == 4){
                $(this).find('.weight-text').html(fourthStep + ' ' + system);
            }
            index ++;
        });


        // Bowel moment
        var poopTimes = '';
        var poopTimesMessage = '';
        if (poop == 'Everyday'){
            poopTimes = '7 Times Per Week';
            poopTimesMessage = 'Your bowel movement is normal';
        }
        else if (poop == 'Twice a week'){
            poopTimes = '3/4 Times Per Week';
            poopTimesMessage = 'Your bowel movement is low';
        }
        else if (poop == 'Once a week'){
            poopTimes = 'Once a week';
            poopTimesMessage = 'Your bowel movement is too low';
        }
        else{
            poopTimes = 'Less than once a week';
            poopTimesMessage = 'Your bowel movement is extremely low';
        }
        $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(2) .icon-text-block__title h4').html(poopTimes);
        $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(2) .icon-text-block__content p').html(poopTimesMessage);

        
    }


    function setFullTable(age, weight, desiredWeight, system, heightMetric, imperialHeightFt, imperialHeightIn, gender){
           
            var genderToWrite;
            console.log(gender, 'GENDERING');
            if (gender == 'male'){
                genderToWrite = 'Male';
            }
            else{
                genderToWrite = 'Female';
            }

            var heightCmIn = 0;
            var weightKg;
            if(system == 'imperial'){
              weigthKg = weight * 0.453592;
              var bmi_type = 'lb';
              var height = imperialHeightFt +'\' '+imperialHeightIn+'"';
              var height_str = 'Height';
              heightCmIn = (parseFloat(imperialHeightFt) * 30.48) + (parseFloat(imperialHeightIn) * 2.54);
            }else{
                var bmi_type = 'kg';
                var height = heightMetric;
                var height_str = 'Height, cm';
                heightCmIn = parseFloat(heightMetric);
                weigthKg = weight;
            }
            
            var summary_data_bmi = calculateBMI(weight, heightMetric , system, imperialHeightFt, imperialHeightIn);

            if (summary_data_bmi < 18.5) {
              var bmi_str = 'You are Underweight'
            } else if (summary_data_bmi >= 18.5 && summary_data_bmi <= 24.9) {
              var bmi_str = 'You are Normal weight'
            } else if (summary_data_bmi > 24.9) {
              var bmi_str = 'You are Overweight'
            }

            let BMR = calculateBMR(weight, heightMetric, age, gender, system, imperialHeightFt, imperialHeightIn);

            var weightChangeAfterMonth = (0.75 * (weight - desiredWeight)).toFixed(1);
            var weightChangeTotal = ((weight - desiredWeight) - weightChangeAfterMonth).toFixed(1);
            

            var metabolismMessage = '';
            
            var idealWeight = (((heightCmIn / 100) * heightCmIn) / 100) * 22.5;

            var weightDiff = parseFloat(weigthKg) - parseFloat(idealWeight);
            var metabolicAge = parseFloat(age);
              
            if (weightDiff > 1 && weightDiff <= 5) {
                metabolicAge = metabolicAge + 3;
            }
            
            if (weightDiff > 5 && weightDiff <= 10) {
                metabolicAge = metabolicAge + 8;
            }
            
            if (weightDiff > 10 && weightDiff <= 20) {
                metabolicAge = metabolicAge + 13;
            }
            
            if (weightDiff > 20 && weightDiff <= 30) {
                metabolicAge = metabolicAge + 18;
            }
            
            if (weightDiff > 30) {
                metabolicAge = metabolicAge + 25;
            }

            console.log(weigthKg, ' ',idealWeight, ' ',age, ' ',metabolicAge, ' ', weightDiff);
            

            if (parseFloat(metabolicAge) > parseFloat(age)){
                metabolismMessage = 'Your metabolism is slower than it should be';
            }
            else{
                metabolismMessage = 'Your metabolism is perfect';
            }
            
            
            $('.weight-estimate-wrap .weight-estimate-graph .weight-progress-wrapper-month .weight-text-1').html('-' + weightChangeAfterMonth+' '+bmi_type);
            $('.weight-estimate-wrap .weight-estimate-graph .weight-progress-wrapper-month .weight-text-2').html('-' + weightChangeTotal+' '+bmi_type);


            $('.icon-text-content .icon-text-block-wrapper-top .icon-text-top-block:eq(0) .icon-text-block__title h4').html(genderToWrite);
            $('.icon-text-content .icon-text-block-wrapper-top .icon-text-top-block:eq(1) .icon-text-block__title h4').html(age);
            $('.icon-text-content .icon-text-block-wrapper-top .icon-text-top-block:eq(2) .icon-text-block__title h4').html(height);
            $('.icon-text-content .icon-text-block-wrapper-top .icon-text-top-block:eq(2) .icon-text-block__subtitle span').html(height_str);
            $('.icon-text-content .icon-text-block-wrapper-top .icon-text-top-block:eq(3) .icon-text-block__title h4').html(weight);
            $('.icon-text-content .icon-text-block-wrapper-top .icon-text-top-block:eq(3) .icon-text-block__subtitle span').html('Weight, '+bmi_type);

            $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(0) .icon-text-block__title h4').html(summary_data_bmi);
            $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(0) .icon-text-block__content p').html(bmi_str);
            $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(1) .icon-text-block__title h4').html(metabolicAge+' years');
            $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(1) .icon-text-block__content p').html(metabolismMessage);
            BMR = Math.round(parseFloat(BMR));
            $('.icon-text-content .icon-text-block-wrapper-bottom .icon-text-bottom-block:eq(3) .icon-text-block__title h4').html(BMR+' kcal');

            // console.log(metabolicAge, 'METABOLIC AGE');
            // console.log(BMR, 'mbr per day');
           
    }
    

    function calculateBMI(weight, heightMetric, system, imperialHeightFt = 0, imperialHeightIn = 0) {
        let bmi;
    
        if (system === 'imperial') {
            // Convert height from feet and inches to inches
            let heightInches = (parseFloat(imperialHeightFt) * 12) + parseFloat(imperialHeightIn);
    
            // Prevent division by zero
            if (heightInches === 0) {
                throw new Error("Height cannot be zero.");
            }
    
            // Calculate BMI for imperial system
            bmi = (weight / (heightInches * heightInches)) * 703;
        } else {
            // Prevent division by zero
            if (heightMetric === 0) {
                throw new Error("Height cannot be zero.");
            }
    
            // Calculate BMI for metric system (height in cm, weight in kg)
            bmi = weight / ((heightMetric / 100) * (heightMetric / 100));
        }
    
        return bmi.toFixed(2); // Return BMI rounded to 2 decimal places
    }

    function calculateBMR(weight, heightMetric, age, gender, system, imperialHeightFt , imperialHeightIn ) {
        let weightKg, heightCm;
    
        if (system === 'imperial') {
            let heightInches = (parseFloat(imperialHeightFt) * 12) + parseFloat(imperialHeightIn);
            heightCm = heightInches * 2.54;
            weightKg = weight / 2.20462;
        } else {
            heightCm = heightMetric;
            weightKg = weight;
        }
    
        let BMR;
        if (gender.toLowerCase() === "male") {
            BMR = (10 * weightKg) + (6.25 * heightCm) - (5 * age) + 5;
        } else {
            BMR = (10 * weightKg) + (6.25 * heightCm) - (5 * age) - 161;
        }
    
        return BMR.toFixed(2);
    }

    function calculateMetabolicAge(BMR, age) {
        let avgBMR20 = 1700; // Approximate midpoint
    
        let metabolicAge = 20 + ((BMR - avgBMR20) / 100) * 10;
    
        return Math.round(metabolicAge);
    }

    setResultsData(poop, age, weight, desiredWeight, system, heightMetric, imperialHeightFt, imperialHeightIn);
    setFullTable(age, weight, desiredWeight, system, heightMetric, imperialHeightFt, imperialHeightIn, gender);

});